import {
  formatCardAvatarUrl,
  formatCardPosterUrl,
  formatDuration,
  toLabel,
} from '@/helpers'
import type { Content } from '@setplex/tria-api'
import { produce } from 'immer'
import { PARAM, PATH } from '~/shared/constants/path'
import type { FormattedContent } from './index.h'

/**
 * This function formats the content fields
 * @param content
 */
export const produceFormattedContent = (content: Content): FormattedContent =>
  produce(content as FormattedContent, (draft) => {
    draft.duration = formatDuration(draft.duration) ?? ''
    draft.poster = formatCardPosterUrl(draft.poster || '')
    if (draft.creator)
      draft.creator = {
        ...draft.creator,
        avatar: formatCardAvatarUrl(draft.creator.avatar || ''),
      }
    draft.labels =
      draft.collections?.map((item) =>
        toLabel(item, `${PATH.MOVIES}?${PARAM.LANGUAGE}=`)
      ) ?? []
  })
